module.exports = __webpack_public_path__ + "img/1.05ca8528.png";